var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerascopeLogomark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 89.9",
    style: {
      enableBackground: "new 0 0 500 89.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F47421;}\n\t.st2{fill:#FCEE26;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verascope_Logomark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "E2_5_",
    className: "st0",
    d: "M498.2,30.2c-6.1-14.7-23-21.6-37.6-15.4c-14.7,6.1-21.6,23-15.4,37.6c6.1,14.7,23,21.6,37.6,15.4 c3.5-1.5,6.6-3.6,9.1-6.1l-11.1-11.3c-0.5,0.5-1,0.9-1.5,1.3c-4.7,3.4-11,3.2-15.5-0.2l34-14.2l0,0l2.3-0.9 C499.6,34.3,499,32.3,498.2,30.2z M464,30.8c5-3.6,11.6-3.2,16,0.7l-21.3,8.9C459,36.8,460.8,33.2,464,30.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "P_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "P_8_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.7,12.7c-15.8,0.2-28.5,13-28.5,28.8h0v48.5h15.8V67.1c4,2,8.5,3.1,13.2,3.1c15.9-0.2,28.6-13.2,28.5-29 C435.6,25.3,422.6,12.5,406.7,12.7z M410.1,54c-6.9,1.7-14-2.5-15.7-9.5c-1.7-6.9,2.5-14,9.5-15.7c6.9-1.7,14,2.5,15.7,9.5 C421.3,45.3,417,52.3,410.1,54z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "O_5_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 342.3,
    cy: 41.4,
    r: 28.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "st0",
    d: "M265.6,12.7c-15.9,0-28.8,12.9-28.8,28.7h0c0,5.9-4,11.2-10,12.6c-2.6,0.6-5.2,0.4-7.6-0.5c0,0,0,0,0,0 l-5.6,14.8c3.2,1.2,6.6,1.9,10.2,1.9c15.9,0,28.8-12.9,28.8-28.7h0c0-5.9,4-11.2,10-12.6c2.6-0.6,5.2-0.4,7.6,0.5c0,0,0,0,0,0 l5.6-14.8C272.6,13.3,269.2,12.7,265.6,12.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "C_23_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_24_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.3,53.5c-0.5,0.2-1.1,0.4-1.6,0.5c-7,1.6-13.9-2.7-15.6-9.6c-0.2-1-0.3-2-0.3-2.9c0-5.9,4-11.2,10-12.6 c2.6-0.6,5.2-0.4,7.6,0.5c0,0,0,0,0,0l5.6-14.8c-3.2-1.2-6.6-1.9-10.2-1.9c-15.9,0-28.8,12.9-28.8,28.8 c0,15.9,12.9,28.8,28.8,28.8c3.6,0,7.1-0.7,10.2-1.9L307.3,53.5C307.3,53.5,307.3,53.5,307.3,53.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "A_3_",
    className: "st0",
    d: "M207.1,41.4c0-15.9-12.9-28.8-28.8-28.8c-15.9,0-28.8,12.9-28.8,28.8c0,15.9,12.9,28.8,28.8,28.8 c4.6,0,9-1.1,12.9-3.1v3.1h15.9L207.1,41.4L207.1,41.4z M181.2,54c-7,1.6-13.9-2.7-15.6-9.6c-1.6-7,2.7-13.9,9.6-15.6 c7-1.6,13.9,2.7,15.6,9.6c0.2,1,0.3,2,0.3,3h0v0.9C190.8,47.8,186.9,52.7,181.2,54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R_3_",
    className: "st0",
    d: "M147.2,0c-12.6,9.4-20.7,24.5-20.7,41.4v28.8h15.8V41.4c0-11.8,5.7-22.2,14.4-28.8L147.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E1_7_",
    className: "st0",
    d: "M116.9,30c-6.1-14.7-23-21.6-37.6-15.4c-14.7,6.1-21.6,23-15.4,37.6c6.1,14.7,23,21.6,37.6,15.4 c3.5-1.5,6.6-3.6,9.1-6.1L99.5,50.3c-0.5,0.5-1,0.9-1.5,1.3c-4.7,3.4-11,3.2-15.5-0.2l34-14.2l0,0l2.3-0.9 C118.4,34.1,117.8,32.1,116.9,30z M82.8,30.6c5-3.6,11.6-3.2,16,0.7l-21.3,8.9C77.7,36.5,79.6,33,82.8,30.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "V_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "33,69.9 0,12.3 66,12.3  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerascopeLogomark);
export default __webpack_public_path__ + "static/media/verascope-logomark.031d35da0b60bda0a942766421991471.svg";
export { ForwardRef as ReactComponent };